export default __webpack_public_path__ + "static/media/picto_Trading_bleu.015eea10.svg";